import Drawer from './AccountNotificationsDrawer';
import AccountNotificationsView from '../../../common/components/AccountNotifications/AccountNotificationsView';
import content from '../../../templates/mcom/components/AccountNotifications/AccountNotificationsComponent.hbs';
import template from '../../../templates/mcom/components/AccountNotifications/NotificationsIcon.hbs';

export default AccountNotificationsView.extend({
  initialize(...args) {
    AccountNotificationsView.prototype.initialize.apply(this, args);
  },
  template,
  createDrawer() {
    if (this.drawer) {
      this.drawer.destroy();
    }
    this.drawer = new Drawer({
      title: 'Inbox',
      content: content(this.model.toJSON()),
    });
    AccountNotificationsView.prototype.createDrawer.call(this);
  },
});
